import { Box, Paper, Stack, useTheme } from '@mui/material'

import AssistantAvatar from '~/features/chatbot/components/assistantAvatar'
import { getChatbotAccentColor } from '~/features/chatbot/utils'
import { store } from '~/store'
import rem from '~/utils/ui'

function LoadingBubbles() {
  const theme = useTheme()
  const [chatbotAgent, chatbotLayout] = store((state) => [
    state.chatbot.agent,
    state.chatbot.layout,
  ])

  const { accentColor } = getChatbotAccentColor({
    layout: chatbotLayout,
    selectedTheme: chatbotLayout.selection.theme,
  })

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      sx={{
        mb: 3,
      }}
    >
      <Box
        sx={{
          borderRadius: '50%',
          padding: rem(3),
        }}
      >
        <AssistantAvatar
          chatbotImgURL={chatbotAgent.chatbotImgURL}
          variant="small"
        />
      </Box>
      <Paper
        elevation={0}
        sx={{
          '&.MuiPaper-root': {
            borderRadius: rem(12),
          },
          p: 2,
          bgcolor: theme.palette.common.white,
          border: `${rem(1)} solid ${theme.palette.divider}`,
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          minWidth: 70,
        }}
      >
        {['0s', '0.2s', '0.4s'].map((delay) => (
          <Box
            key={delay}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: accentColor,
              animation: 'bounce 1.4s infinite ease-in-out',
              animationDelay: delay,
              '@keyframes bounce': {
                '0%, 80%, 100%': {
                  transform: 'scale(0)',
                  opacity: 0.5,
                },
                '40%': {
                  transform: 'scale(1)',
                  opacity: 1,
                },
              },
            }}
          />
        ))}
      </Paper>
    </Stack>
  )
}

export default LoadingBubbles
